import React from 'react';
// TODO: Re-enable when refill form is needed - import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteConfirmationModal = (props) => {
  const {
    show,
    centered,
    name,
    module,
    handleToggle,
    handleDelete,
    wording,
    title,
    buttonName,
    handleCancelSubWithoutEmail = null,
    // TODO: Re-enable refill form props when needed
    // showRefillForm = false,
    // totalRefillsApproved = 0,
    // totalRefillsOrdered = 0,
  } = props;
  
  // TODO: Re-enable refill form state when needed
  // const [numberOfRefills, setNumberOfRefills] = useState('');
  return (
    <Modal
      show={show}
      onHide={handleToggle}
      centered={centered || true}
      className="custom_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className="text-danger fs-6">
            {title ? title : `Delete ${module}`}
          </h5>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {wording
          ? wording
          : `Are you sure you want to delete ${name} ${module}?`}
        
        {/* TODO: Re-enable refill form when needed - Refill form section - This has been added to address the scenario when the approved refills are more than what we need to send order for.
        {showRefillForm && (
          <div className="mt-3">
            <div className="mb-3">
              <label className="form-label fw-bold">Total Refills Approved:</label>
              <div className="form-control-plaintext">{totalRefillsApproved}</div>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Total Refills Ordered:</label>
              <div className="form-control-plaintext">{totalRefillsOrdered}</div>
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Number of Refills to Order:</label>
              <input
                type="number"
                className="form-control"
                value={numberOfRefills}
                onChange={(e) => setNumberOfRefills(e.target.value)}
                placeholder="Enter number of refills"
                min="0"
              />
            </div>
          </div>
        )}
        */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="sky" size="sm" onClick={handleToggle}>
          Close
        </Button>
        {handleCancelSubWithoutEmail != null ? (
          <>
            <Button size="sm" onClick={handleDelete}>
              Cancel with Email
            </Button>
            <Button size="sm" onClick={handleCancelSubWithoutEmail}>
              Cancel without Email
            </Button>
          </>
        ) : (
          <Button 
            size="sm" 
            onClick={handleDelete}
            // TODO: Re-enable refill form logic when needed
            // onClick={() => {
            //   if (showRefillForm) {
            //     handleDelete(numberOfRefills);
            //   } else {
            //     handleDelete();
            //   }
            // }}
          >
            {buttonName ? buttonName : `Delete`}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmationModal;
